import * as React from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'

import { TextScroller } from '../components/TextScroller'
import { Project, ProjectData } from '../components/Project'
import { Layout } from '../components/layout'

// Please note that you can use https://github.com/dotansimha/graphql-code-generator
// to generate all types from graphQL schema
interface IndexPageProps {
  data: {
    headerImage: any
    projects: {
      edges: {
        node: {
          frontmatter: ProjectData
          htmlAst: any
        }
      }[]
    }
    site: {
      siteMetadata: {
        title: string
      }
    }
  }
}

export default class extends React.Component<IndexPageProps, {}> {
  constructor(props: IndexPageProps, context: any) {
    super(props, context)
  }
  public render() {
    const projects = this.props.data.projects.edges.map(edge => {
      return {
        title: edge.node.frontmatter.title,
        htmlAst: edge.node.htmlAst,
        image:
          edge.node.frontmatter.image &&
          edge.node.frontmatter.image.childImageSharp,
        video: edge.node.frontmatter.video,
      }
    })
    console.log(projects, this.props.data)
    return (
      <Layout>
        <section>
          <h2>Makers of beautiful high performance apps</h2>
          <p>
            Ever been frustrated with a sluggish app? Nowadays, many companies
            need apps for internal use, or to promote their brand. For apps that
            are only used internally, features are often king and the apps are
            often anything but delightful to use.
          </p>
          <p>
            We think all apps should be delightful to use. By utilizing the
            latest cross platform app development techniques we achieve
            beautiful apps that you and your users will <b>love</b>.
          </p>
        </section>
        <section>
          <h2>Our projects</h2>
          {projects.map((project, i) => (
            <Project project={project} key={i} />
          ))}
        </section>
      </Layout>
    )
  }
}

export const pageQuery = graphql`
  query IndexQuery {
    headerImage: imageSharp(fluid: { originalName: { regex: "/hero/" } }) {
      sizes(maxWidth: 2560, quality: 90) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
    site {
      siteMetadata {
        title
      }
    }
    projects: allMarkdownRemark(
      sort: { order: ASC, fields: [frontmatter___order] }
      filter: { fileAbsolutePath: { regex: "/projects/" } }
    ) {
      edges {
        node {
          htmlAst
          frontmatter {
            title
            video {
              publicURL
            }
          }
        }
      }
    }
  }
`
